/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Session_Minutes_ShortInputs */

const en_us2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fits the plan to the clock`)
};

const pt_br2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta o plano ao relógio`)
};

const es_419_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta el plan al reloj`)
};

const pt_pt2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta o plano ao relógio`)
};

const fr_fr2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte le programme à l'horloge`)
};

const de_de2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passt den Plan an die Uhr an`)
};

const it_it2_intake_why_session_minutes_short = /** @type {(inputs: Intake_Why_Session_Minutes_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta la scheda all'orologio`)
};

/**
* | output |
* | --- |
* | "Fits the plan to the clock" |
*
* @param {Intake_Why_Session_Minutes_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_session_minutes_short = /** @type {((inputs?: Intake_Why_Session_Minutes_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Session_Minutes_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_session_minutes_short(inputs)
	if (locale === "es-419") return es_419_intake_why_session_minutes_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_session_minutes_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_session_minutes_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_session_minutes_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_session_minutes_short(inputs)
	return en_us2_intake_why_session_minutes_short(inputs)
});
export { intake_why_session_minutes_short as "intake.why.session_minutes.short" }